import { IDropdownItem } from '../../../../../ui';
import Downshift, { DownshiftState, StateChangeOptions } from 'downshift';
import { useCallback } from 'react';
import { getValueForItem } from './getValueForItem';

export function useSelectItemOnBlur<TItemType extends IDropdownItem>(
	items: TItemType[],
) {
	return useCallback(
		(
			state: DownshiftState<TItemType>,
			changes: StateChangeOptions<TItemType>,
		) => {
			if (changes.type !== Downshift.stateChangeTypes.blurInput) {
				return changes;
			}

			if (!shouldSelectItem(state)) {
				return changes;
			}

			const selectedItem = items[state.highlightedIndex ?? 0];
			const inputValue = getValueForItem(selectedItem);

			return {
				...changes,
				selectedItem,
				inputValue,
			};
		},
		[items],
	);
}

function shouldSelectItem<TItemType extends IDropdownItem>(
	state: DownshiftState<TItemType>,
) {
	return state.inputValue !== '' || state.isOpen === true;
}
